module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/074-kazakhstan-86c9226d0a9875864c3b635ac4921371.svg";